// shared-components/components/Header.jsx
import React from 'react';
import CompudoptLogo from './Logo';

function Header({ 
  appName = "Compudopt Helper",
  lang, 
  setLang, 
  onlineStatus,
  showOnlineToggle = false
}) {
  return (
    <header 
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 50,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(12px)',
        borderBottom: '1px solid var(--border-default)',
        padding: 'var(--space-4) 0'
      }}
    >
      <div 
        style={{
          maxWidth: '1280px',
          margin: '0 auto',
          padding: '0 24px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        {/* Left: Logo + Title */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
          <CompudoptLogo size={36} />
          <h1 style={{ 
            fontSize: '20px',
            fontWeight: 'var(--font-semibold)',
            color: 'var(--gray-900)',
            margin: 0
          }}>
            {appName}
          </h1>
        </div>
        
        {/* Right: Controls */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-3)' }}>
          {/* Language Toggle */}
          <button 
            style={{
              padding: 'var(--space-2) var(--space-3)',
              borderRadius: 'var(--radius-sm)',
              border: '1px solid var(--gray-400)',
              background: 'var(--bg-primary)',
              fontSize: '14px',
              fontWeight: 'var(--font-medium)',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: 'var(--space-2)',
              transition: 'all var(--duration-normal)'
            }}
            onClick={() => setLang(lang === 'en' ? 'es' : 'en')}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = 'var(--bg-tertiary)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'var(--bg-primary)';
            }}
            aria-label="Switch language"
          >
            <span>🌐</span>
            {lang === 'en' ? 'ES' : 'EN'}
          </button>
          
          {/* Online Status (On-Device Only) */}
          {showOnlineToggle && (
            <div 
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 'var(--space-2)',
                paddingLeft: 'var(--space-3)',
                marginLeft: 'var(--space-3)',
                borderLeft: '1px solid var(--gray-400)'
              }}
            >
              <span style={{ fontSize: '14px', color: 'var(--gray-600)' }}>
                {onlineStatus ? 'Online' : 'Offline'}
              </span>
              <div 
                style={{
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  background: onlineStatus ? 'var(--compudopt-green)' : 'var(--gray-500)'
                }}
                aria-label={onlineStatus ? 'Connected' : 'Disconnected'}
              />
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default Header;
